<card-expanding
  [formGroup]="form"
  [valid]="productValidity.getCardStatusValidType(cardSection)"
  [expanded]="isExpanded"
  (onExpand)="saveLocalExpandedValue($event)"
>
  <span header-title>{{ title | translate}}</span>

  <div header-actions *requiredRights="[UserAction.ManageProducts]">
    <ng-container *ngIf="isOwnProduct">
      <locked-info *ngIf="!edit && locked" [locked]="locked"></locked-info>
      <ng-container *ngIf="!edit && !locked">
        <lxm-button
          type="beige"
          icon="edit"
          title="action.edit"
          (click)="toggleEdit()"
        ></lxm-button>
      </ng-container>
      <ng-container *ngIf="edit">
        <lxm-button
          type="grey"
          icon="back"
          label="action.cancel"
          (click)="toggleEdit()"
        ></lxm-button>
        <lxm-button
          type="beige"
          icon="save"
          label="action.save"
          [loading]="saveLoading"
          (click)="save()"
          buttonType="submit"
        ></lxm-button>
      </ng-container>
    </ng-container>
  </div>

  <div body>
    <div class="grid w-full grid-cols-1 gap-4 xl:grid-cols-2">
      <div class="flex flex-col">
        <form-field for="raisedCountry"
          label="cards.products.product_meat.label.raised"
          description="cards.products.product_meat.label_description.raised"
          [readonly]="!edit"
        >
          <lxm-select for="raisedCountry"
            select
            [readonly]="!edit"
            [options]="countryOptions"
            [isTranslated]="true"
            labelField="translatedName"
            [sortByLabel]="true"
            [searchable]="true"
            labelIconField="iso3"
            labelIconFallback="global"
            labelIconClass="flag-icon"
          >
          </lxm-select>
          <validation-errors for="raisedCountry"></validation-errors>
          <validation-errors for="raisedCountryId"></validation-errors>
        </form-field>

        <form-field for="slaughteredCountry"
          label="cards.products.product_meat.label.slaughtered"
          description="cards.products.product_meat.label_description.slaughtered"
          [readonly]="!edit"
        >
          <lxm-select for="slaughteredCountry"
            select
            [readonly]="!edit"
            [options]="countryOptions"
            [isTranslated]="true"
            labelField="translatedName"
            [sortByLabel]="true"
            [searchable]="true"
            labelIconField="iso3"
            labelIconFallback="global"
            labelIconClass="flag-icon"
          >
          </lxm-select>
          <validation-errors for="slaughteredCountry"></validation-errors>
          <validation-errors for="slaughteredCountryId"></validation-errors>
        </form-field>

        <form-field for="countryWhereProductWasCut"
          label="cards.products.product_meat.label.country_where_product_was_cut"
          description="cards.products.product_meat.label_description.country_where_product_was_cut"
          [readonly]="!edit"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CountryWhereProductWasCut, form.get('countryWhereProductWasCut').value)"
        >
          <lxm-select for="countryWhereProductWasCut"
            select
            [readonly]="!edit"
            [options]="countryOptions"
            [isTranslated]="true"
            labelField="translatedName"
            [sortByLabel]="true"
            [searchable]="true"
            labelIconField="iso3"
            labelIconFallback="global"
            labelIconClass="flag-icon"
          >
          </lxm-select>
          <validation-errors
            for="countryWhereProductWasCut"
          ></validation-errors>
          <validation-errors
            for="countryWhereProductWasCutId"
          ></validation-errors>
        </form-field>
      </div>

      <div class="flex flex-col">
        <form-field for="porkMeatPartPictograms"
          label="cards.products.product_meat.label.pork_meat_part_pictograms"
          description="cards.products.product_meat.label_description.pork_meat_part_pictograms"
          [readonly]="!edit"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.PorkMeatPartPictograms, form.get('porkMeatPartPictograms').value?.length > 0)"
        >
          <lxm-select for="porkMeatPartPictograms"
            select
            class="w-full"
            [readonly]="!edit"
            [options]="porkMeatPartPictogramOptions"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [searchable]="true"
            [multiple]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="porkMeatPartPictograms"></validation-errors>
        </form-field>

        <form-field for="cattleBeefMeatPartPictograms"
          label="cards.products.product_meat.label.cattle_beef_meat_part_pictograms"
          description="cards.products.product_meat.label_description.cattle_beef_meat_part_pictograms"
          [readonly]="!edit"
          [validationResultType]="productValidity.isRequiredByRetailer(cardSection, productField.CattleBeefMeatPartPictograms, form.get('cattleBeefMeatPartPictograms').value?.length > 0)"
        >
          <lxm-select for="cattleBeefMeatPartPictograms"
            select
            class="w-full"
            [readonly]="!edit"
            [options]="cattleBeefMeatPartPictogramOptions"
            value="id"
            labelField="translatedValue"
            [isTranslated]="true"
            [searchable]="true"
            [multiple]="true"
            [sortByLabel]="true"
          >
          </lxm-select>
          <validation-errors for="cattleBeefMeatPartPictograms"></validation-errors>
        </form-field>
      </div>
    </div>
  </div>
</card-expanding>
